<template>
  <div>
    <el-dialog :visible.sync="$store.getters.showMainSlidesDialog" width="80%" :before-close="handleClose">
      <el-container v-loading="isLoading">
        <el-header height="auto">
          <el-row>
            <el-col :span="18">
              <h4 v-if="parentSection.title">{{ parentSection.title }}</h4>
              <h4 v-else>Выбор ресурса</h4>
            </el-col>
            <el-col :span="6">
              <el-checkbox v-model="isSelected">
                Только выбранные
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row v-if="oldSections.length">
            <div class="catalog-sections-page__top-buttons">
              <el-button @click="onParentSection">
                Назад
              </el-button>
              <el-button @click="onRootSection">
                Сбросить
              </el-button>
            </div>
          </el-row>
        </el-header>
        <el-main height="80%">
          <el-form aria-label="Поиск" label-width="150px" label-position="left">
            <el-row>
              <el-col :lg="12" :xl="8">
                <el-form-item label="Поиск по названию">
                  <el-col :span="14">
                    <el-input v-model="query.q" @change="changeRequest"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="itemsComputed" style="width: 100%" empty-text="Нет данных">
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-checkbox :value="includeInChecked(itemsComputed[scope.$index])"
                  @change="changeChecked(itemsComputed[scope.$index])"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="id" label="Id" width="120"> </el-table-column>
            <el-table-column v-if="typeItem !== 'CatalogSection'" prop="title" label="Название"> </el-table-column>
            <el-table-column v-else prop="title" label="Название">
              <template slot-scope="scope">
                <el-button type="text" class="main-slide-section__dialog"
                  @click="onSection(scope.row.id, scope.row.title)">
                  {{ scope.row.title }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
        <el-footer height="5%">
          <el-pagination background layout="prev, pager, next" :total="paginator.total"
            :current-page.sync="paginator.current_page" @current-change="getPage(paginator.current_page)"
            :hide-on-single-page="true" :page-size="paginator.per_page" :page-count="paginator.last_page">
          </el-pagination>
        </el-footer>

      </el-container>
      <template #footer v-if="!isLoading">
        <span class="dialog-footer">
          <el-button @click="handleClose">
            Отмена
          </el-button>
          <el-button type="primary" @click="saveCheckedProducts">
            Сохранить
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { stringify } from "qs";

export default {
  props: ["typeItem", "selectedPropsItems"],
  data: function () {
    return {
      items: [],
      paginator: {},
      isLoading: false,
      section: { id: 0, title: '' },
      parentSection: { id: 0, title: '' },
      oldSections: [],
      query: {
        q: "",
        page: 1,
      },
      selectedItems: [],
      isSelected: false,
      unsubscribe: () => { },
    }
  },
  computed: {
    queryComputed() {
      const result = {}
      if (this.typeItem) {
        result['model_name'] = this.typeItem;
      }
      if (this.query.page) {
        result['page'] = this.query.page;
      }
      if (this.query.q) {
        result['q'] = this.query.q;
      }

      return Reflect.ownKeys(result).length ? result : undefined;
    },
    itemsComputed() {
      if (this.isSelected) {
        return this.selectedItems
      }
      return this.items
    }
  },
  mounted() {
    this.initSelectedItems()
    this.fetch()
    // this.unsubscribe = this.$store.subscribe((mutation) => {
    //   if (mutation.type === 'showMainSlidesDialog' && mutation.payload) {
    //     this.initSelectedItems()
    //     this.fetch()
    //   }
    // })
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.reset()
      this.unsubscribe()
    }
  },
  methods: {
    fetch(query) {
      let q;

      if (query) {
        q = query
      } else {
        q = this.queryComputed ? `?${stringify(this.queryComputed)}` : "";
      }
      this.isLoading = true
      axios.get('/content/main-slide/model-type/objects' + q)
        .then((response) => {
          this.items = response.data.data;
          this.paginator = response.data.meta;
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        })
        .finally(() => { this.isLoading = false })
    },
    onSection(id, title) {
      this.oldSections.push({
        id: this.section.id,
        title: this.section.title,
      });
      this.parentSection = {
        id: id,
        title: title,
      };
      this.section = {
        id, title,
      }
      this.fetch(`?${stringify({ section_id: this.section.id, model_name: this.typeItem })}`);
    },
    onParentSection() {
      const temp = this.oldSections.pop();
      const result = { section_id: temp?.id ?? 0, model_name: this.typeItem };
      if (temp && temp?.id <= 0) {
        delete result.section_id;
        this.section = { id: 0, title: '' };
        this.parentSection = { id: 0, title: '' };
      } else {
        this.parentSection = { id: temp?.id ?? 0, title: temp?.title ?? '' }
        this.section = { id: temp?.id ?? 0, title: temp?.title ?? '' }
      }

      this.fetch(`?${stringify(result)}`);
    },
    onRootSection() {
      this.oldSections = [];
      this.section = { id: 0, title: '' };
      this.parentSection = { id: 0, title: '' };
      this.fetch(`?${stringify({ model_name: this.typeItem })}`);
    },
    getPage(pageNum) {
      this.query.page = pageNum ?? 1;
      this.fetch();
    },
    getEmitItems() {
      return this.selectedItems.length ? { id: this.selectedItems[0].id, title: this.selectedItems[0].title } : []
    },
    changeRequest() {
      this.fetch()
    },
    changeChecked(item) {
      const findIndex = this.selectedItems.findIndex((e) => e.id === item.id);

      if (findIndex < 0 && item) {
        this.selectedItems = [{ id: item.id, title: item.title }]
      } else {
        this.selectedItems = []
      }

    },
    includeInChecked(item) {
      return !!this.selectedItems.find((e) => e.id === item.id);
    },
    saveCheckedProducts() {
      this.$emit("selectItem", this.getEmitItems());
      this.handleClose()
    },
    reset() {
      this.isSelected = false
      this.resetSelected()
      this.oldSectionId = []
      this.sectionId = 0
    },
    resetSelected() {
      this.selectedItems = []
    },
    initSelectedItems() {
      if (this.selectedPropsItems.length) {
        this.selectedItems = this.selectedPropsItems.map((e) => ({ id: e.id, title: e.title }));
      }
    },
    handleClose() {
      this.$store.commit("showMainSlidesDialog", false);
      this.ids = [];
    },
  }
}
</script>

<style>
.main-slide-section__dialog span {
  color: #606266;
}

.main-slide-section__dialog:hover span {
  color: #409EFF;
}
</style>